import React, { useMemo } from 'react';
import { IStormDoorModel } from '../../../../entities-generated/models/storm-door/storm-door-model';
import { ProductTile } from '../product-tile';
import { DoorRecommendation } from '../../../../entities-generated/common/door-recommendation';

interface IStormDoorTileProps {
  idPrefix: string;
  door: IStormDoorModel;
  onSelected: (door: IStormDoorModel) => void;
  recommendation: DoorRecommendation;
}

export const StormDoorTile: React.FunctionComponent<IStormDoorTileProps> = (props) => {
  const { door } = props;
  const ratingProps = useMemo(() => {
    const pr = door.productReview;
    return pr.totalReviewCount > 0 ? {
        rating: door.rating,
        reviewerCount: door.productReview.totalReviewCount
      } : undefined;
  }, [door]);

  return (
    <ProductTile
      id={door.id}
      idPrefix={props.idPrefix}
      imageUrls={door.textureVariants[0].productImageUrls}
      brand={door.brand}
      description={door.description}
      textures={door.textureVariants}
      price={door.price}
      ratingProps={ratingProps}
      onProductSelected={() => props.onSelected(door)}
      recommendation={props.recommendation}
    />
  );
};
